(function (Drupal, once) {
  'use strict';

  // Ensure shared namespace exists (should be created by mcmn-utils.js)
  window.McmnExperience = window.McmnExperience || {};
  const Mcmn = window.McmnExperience;

  /**
   * Attach behavior
   */
  Drupal.behaviors.mcmnExperience = {
    attach: function (context, settings) {
      // Add body classes if user has completed the experience and/or has gated access
      if (Mcmn.CookieManager) {
        if (Mcmn.CookieManager.hasCompleted()) {
          document.body.classList.add('mcmn-experience-completed');
        }
        if (Mcmn.CookieManager.hasGatedAccess()) {
          document.body.classList.add('mcmn-gated-access');
        }
        
        // Update gated content visibility on page load
        if (Mcmn.updateGatedContentVisibility) {
          setTimeout(function() {
            Mcmn.updateGatedContentVisibility();
          }, 100);
        }
      }
      
      once('mcmn-experience', '.mcmn-experience-component', context).forEach(function (component) {
        // Initialize modal (welcome/completion) - TEMPORARILY DISABLED FOR TESTING
        if (Mcmn.initModal) {
          Mcmn.initModal(component);
        }
        
        // Initialize fullscreen button
        if (Mcmn.initFullscreenButton) {
          Mcmn.initFullscreenButton();
        }
        
        // Initialize rotation overlay
        if (Mcmn.initRotationOverlay) {
          Mcmn.initRotationOverlay(component);
        }
        
        // Initialize section navigation
        if (Mcmn.initSectionNavigation) {
          Mcmn.initSectionNavigation(component);
        }
        
        // Initialize experience after a short delay to allow fade-in to complete
        setTimeout(function() {
          if (Mcmn.initMcmnExperience) {
            Mcmn.initMcmnExperience(component);
          }
        }, 500);
      });
    }
  };

})(Drupal, once);